import { Component, Inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Fase } from '../../../../shared/models/fase';
import { FaseService } from '../../../../shared/services/fase.service';
import { ToastService } from '../../../../shared/services/toast.service';
import { ToastState as ts } from '../../../../shared/enums/toast-state.enum';
import { InputComponent } from '../../../../shared/components/input/input.component';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';

@Component({
  selector: 'app-dialog-fase',
  imports: [ModalComponent, InputComponent, ReactiveFormsModule],
  templateUrl: './dialog-fase.component.html',
  styleUrl: './dialog-fase.component.scss',
})
export class DialogFaseComponent {
  form: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<DialogFaseComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      fase: Fase | null;
    },
    private fb: FormBuilder,
    private faseService: FaseService,
    private toast: ToastService,
  ) {
    this.form = this.fb.group({
      id: [data?.fase?.id ?? 0],
      nome: [
        data?.fase?.nome ?? '',
        [Validators.required, Validators.maxLength(20)],
      ],
      sequencia: [
        data?.fase?.sequencia ?? 0,
        [Validators.required, Validators.max(100)],
      ],
    });
  }

  onSave(formData: any) {
    const dto: Fase = {
      id: formData.id,
      nome: formData.nome,
      sequencia: formData.sequencia,
    };
    if (dto.id > 0) {
      this.update(dto);
    } else {
      this.insert(dto);
    }
  }

  private insert(data: Fase) {
    this.faseService.insert(data).subscribe({
      next: (result) => {
        if (result.success) {
          this.toast.showToast(ts.success, 'Fase criada com sucesso!');
          this.dialogRef.close(result.content);
        }
      },
      error: (e) => {
        this.toast.showToast(ts.error, e.error[0]);
        this.dialogRef.close();
      },
    });
  }

  private update(data: Fase) {
    this.faseService.update(data).subscribe({
      next: (result) => {
        if (result.success) {
          this.toast.showToast(ts.success, 'Fase atualizada');
          this.dialogRef.close(result.content);
        } else {
          this.toast.showToast(ts.error, result.messages[0]);
        }
      },
      error: (e) => {
        this.toast.showToast(ts.error, e.error[0]);
        this.dialogRef.close();
      },
    });
  }
}
